import { unstableSetRender } from 'antd-mobile';
import { createRoot, type Root } from 'react-dom/client';

type CompatibleContainer = Element & {
  __antdMobileRoot__?: Root;
};

// React 19 removes the legacy react-dom mount API.
// antd-mobile exposes unstableSetRender specifically for this compatibility layer.
unstableSetRender((node, container) => {
  const target = container as CompatibleContainer;
  if (!target.__antdMobileRoot__) {
    target.__antdMobileRoot__ = createRoot(container);
  }

  const root = target.__antdMobileRoot__;
  root.render(node);

  return async () => {
    await new Promise<void>((resolve) => {
      window.setTimeout(resolve, 0);
    });
    root.unmount();
    delete target.__antdMobileRoot__;
  };
});
